__turbopack_context__.v({
  "carousel": "HubDestinationFacets-module__ubGO_G__carousel",
  "scroller": "HubDestinationFacets-module__ubGO_G__scroller",
  "slide": "HubDestinationFacets-module__ubGO_G__slide",
  "title": "HubDestinationFacets-module__ubGO_G__title",
});
